// @ts-strict-ignore
export function handleInterceptError(error) {
  // to ensure code that expects legacy errors works as expected we "unwrap" the actual error details that axios
  // returns nested under the "response" property.
  return Promise.reject({ ...error, ...error.response });
}
